import { Injectable } from '@angular/core';

/**
 * In-memory unlock flag for the biometric lock gate. Resets to "locked" on
 * every cold start (new webview JS context), so a keystore-restored session
 * must pass biometrics once per app launch before the authenticated area is
 * shown. A successful password login also counts as unlocked for that session.
 */
@Injectable({ providedIn: 'root' })
export class LockStateService {
  private unlocked = false;

  markUnlocked(): void {
    this.unlocked = true;
  }

  reset(): void {
    this.unlocked = false;
  }

  isUnlocked(): boolean {
    return this.unlocked;
  }
}
